"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleDirection = exports.createStyles = exports.SortableLabel = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
function SortableLabel(props) {
    var direction = props.direction, onChange = props.onChange, children = props.children;
    var classes = styles_1.useStyles(exports.createStyles, props).classes;
    var handleClick = function (event) {
        onChange(exports.toggleDirection(direction), event.shiftKey);
    };
    return (react_1.default.createElement("span", { className: classes.wrapper, onClick: handleClick },
        children,
        react_1.default.createElement(Sort, { className: classes.icon, classes: {
                up: classes.asc,
                down: classes.desc,
            } })));
}
exports.SortableLabel = SortableLabel;
exports.createStyles = function (theme, _a) {
    var direction = _a.direction;
    return ({
        wrapper: {
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
        },
        icon: {
            marginLeft: '0.25rem',
            fontSize: '1rem',
            fill: theme.pallete.text.disabled,
        },
        asc: {
            fill: direction === 'ASC' && theme.pallete.primary.main,
        },
        desc: {
            fill: direction === 'DESC' && theme.pallete.primary.main,
        },
    });
};
exports.toggleDirection = function (dir) {
    return (dir === 'ASC' && 'DESC') || (dir === 'DESC' && 'ASC') || 'ASC';
};
var Sort = function (props) {
    var classes = props.classes, rest = __rest(props, ["classes"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: '0 0 24 24', width: '1em', height: '1em' }, rest),
        react_1.default.createElement("polygon", { points: '12 4.94 16.95 9.89 18.36 8.47 12 2.11 5.64 8.47 7.05 9.89 12 4.94', className: classes.up }),
        react_1.default.createElement("polygon", { points: '12 19.06 7.05 14.11 5.64 15.53 12 21.89 18.36 15.53 16.95 14.11 12 19.06', className: classes.down })));
};
//# sourceMappingURL=SortableLabel.js.map